import { Icon as IconifyIcon } from '@iconify/react'
import { useGet, useSet, useLastResolved } from 'ccstate-react'
import { searchQuery$, searchSuggestions$ } from '../state'
import { updateSearchQuery$, clearSearchQuery$ } from '../commands'
import { navigateInReact$ } from '../infra/router/navigate'
import TabBar from '../components/TabBar'
export default function SearchPage() {
  const query = useGet(searchQuery$)
  const suggestions = useLastResolved(searchSuggestions$) || []
  const updateQuery = useSet(updateSearchQuery$)
  const clearQuery = useSet(clearSearchQuery$)
  const navigate = useSet(navigateInReact$)
  const handleSuggestionClick = (word: string) => {
    navigate(`/word/${word}` as '/word/:word')
  }
  return (<div className="min-h-screen bg-[#F7F8FA] pb-20" data-id="464qqv">
    <div className="p-4" data-id="9askxu">
      {/* Search Input */}
      <div className="relative" data-id="862pwo">
        <div className="flex items-center border-[1.5px] border-[#D4DBE6] rounded-md bg-[#F7F8FA] px-3 py-2 focus-within:border-[2px] focus-within:border-[#1E3A5F] focus-within:bg-[#E8EDF3]" data-id="pmhupu">
          <IconifyIcon icon="lucide:search" className="text-xl text-[#5A6B7D] mr-2" data-id="lq39mh"/>
          <input type="text" value={query} onChange={(e) => updateQuery(e.target.value)} placeholder="输入单词查询" className="flex-1 outline-none text-base text-[#1A1A1A] placeholder-[#9BA8B8] bg-transparent" data-testid="search-input" data-id="h1telv"/>
          {query && (<button onClick={clearQuery} className="ml-2" data-testid="clear-button" data-id="h2tj2o">
            <IconifyIcon icon="lucide:x" className="text-xl text-[#5A6B7D]" data-id="ydp2ir"/>
          </button>)}
        </div>
      </div>

      {/* Search Suggestions */}
      {query && suggestions.length > 0 && (<div className="mt-4 border border-[#D4DBE6] rounded-md bg-[#F7F8FA]" data-testid="suggestions-list" data-id="0z3fva">
        {suggestions.map((word, index) => (<button key={word} onClick={() => handleSuggestionClick(word)} className={`w-full text-left px-4 py-3 ${index !== suggestions.length - 1 ? 'border-b border-[#E8EDF3]' : ''} hover:bg-[#E8EDF3] transition-colors`} data-testid={`suggestion-${word}`} data-id="qxwboy">
          <span className="text-base text-[#1A1A1A]" data-id="t4fohr">{word}</span>
        </button>))}
      </div>)}

      {/* Empty State */}
      {!query && (<div className="flex flex-col items-center justify-center mt-32" data-id="fhkwuy">
        <IconifyIcon icon="lucide:book-open" className="text-[80px] text-[#D4DBE6] mb-4" data-id="q9h2hf"/>
        <p className="text-base text-[#5A6B7D] mb-2" data-id="h1ouwq">开始查词</p>
        <p className="text-sm text-[#9BA8B8]" data-id="46urqv">输入单词以查看释义</p>
      </div>)}

      {/* No Results State */}
      {query && suggestions.length === 0 && (<div className="flex flex-col items-center justify-center mt-32" data-id="8ibnos">
        <IconifyIcon icon="lucide:search-x" className="text-[80px] text-[#D4DBE6] mb-4" data-id="gm31ik"/>
        <p className="text-base text-[#5A6B7D]" data-id="uirtho">未找到相关单词</p>
      </div>)}
    </div>

    <TabBar data-id="gr912w"/>
  </div>)
}
